<template>
  <nav
    class="sb-topnav navbar navbar-expand navbar-dark modern-nav shadow-sm fixed-top"
  >
    <div class="container-fluid px-3">
      <router-link
        class="navbar-brand d-flex align-items-center"
        to="/dashboard"
      >
        <img
          :src="require('@/assets/logo-text-white.png')"
          alt="Logo"
          style="height: 35px"
          class="me-2"
        />
      </router-link>

      <button
        class="btn btn-link btn-sm order-1 order-lg-0 sidebar-toggle"
        @click="toggleSidebar"
      >
        <font-awesome-icon icon="bars-staggered" />
      </button>

      <ul class="navbar-nav ms-auto align-items-center">
        <li class="nav-item dropdown">
          <a
            class="nav-link profile-dropdown-toggle d-flex align-items-center gap-2"
            id="navbarDropdown"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span class="d-none d-md-inline text-white small fw-bold">{{
              userFullName
            }}</span>
            <div class="user-avatar shadow-sm border border-2 border-white-50">
              <span class="avatar-initials">{{
                userFullName ? userFullName.charAt(0) : "U"
              }}</span>
            </div>
          </a>

          <ul
            class="dropdown-menu dropdown-menu-end border-0 shadow-lg mt-3 p-2 profile-menu"
          >
            <li
              class="p-3 mb-2 bg-soft-primary rounded-3 d-flex align-items-center gap-3"
            >
              <div class="user-avatar-lg">
                {{ userFullName ? userFullName.charAt(0) : "U" }}
              </div>
              <div class="overflow-hidden">
                <h6
                  class="mb-0 fw-bold text-dark text-truncate"
                  style="max-width: 150px"
                >
                  {{ userFullName }}
                </h6>
                <small class="text-muted text-xs d-block text-truncate"
                  >{{ userLevel }} Account</small
                >
              </div>
            </li>

            <li>
              <router-link to="/profil" class="dropdown-item rounded-2 py-2">
                <font-awesome-icon icon="user-gear" class="me-2 text-success" />
                Profil Saya
              </router-link>
            </li>
            <li>
              <router-link to="/dashboard" class="dropdown-item rounded-2 py-2">
                <font-awesome-icon
                  icon="chart-line"
                  class="me-2 text-success"
                />
                Dashboard
              </router-link>
            </li>

            <li><hr class="dropdown-divider opacity-10" /></li>

            <li>
              <a
                @click="logout"
                class="dropdown-item rounded-2 py-2 text-danger fw-bold"
                href="javascript:;"
              >
                <font-awesome-icon icon="right-from-bracket" class="me-2" />
                Keluar
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import Swal from "sweetalert2";
import userData from "@/plugins/userData";

export default {
  mixins: [userData],
  name: "NavBar",
  data() {
    return {
      id: "",
    };
  },
  created() {
    const user = localStorage.getItem("userData");
    if (user) {
      this.user = JSON.parse(user);
      this.id = this.user.id;
    }
  },
  methods: {
    toggleSidebar() {
      document.body.classList.toggle("sb-sidenav-toggled");
      localStorage.setItem(
        "sb|sidebar-toggle",
        document.body.classList.contains("sb-sidenav-toggled")
      );
    },
    logout() {
      Swal.fire({
        title: "Apakah Anda Akan Logout ?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Logout!",
      }).then((result) => {
        if (result.value) {
          localStorage.removeItem("userData");
          if (this.$route.path !== "/login") {
            this.$router.push("/login");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.modern-nav {
  background: linear-gradient(135deg, #558e19 0%, #1d4731 100%);
  padding: 0.75rem 0;
  z-index: 1050 !important;
  position: sticky;
}

.brand-icon {
  background: rgba(255, 255, 255, 0.2);
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.brand-text {
  font-weight: 800;
  letter-spacing: 1px;
}

.sidebar-toggle {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin-left: 10px;
  transition: all 0.2s;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Avatar Navbar */
.user-avatar {
  width: 38px;
  height: 38px;
  background: white;
  color: #558e19;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  transition: transform 0.2s;
}

.profile-dropdown-toggle:active .user-avatar {
  transform: scale(0.9);
}

/* Dropdown Menu Styles */
.profile-menu {
  width: 260px;
  border-radius: 15px !important;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bg-soft-primary {
  background-color: #f0f7ff;
}

.user-avatar-lg {
  width: 45px;
  height: 45px;
  background: #558e19;
  color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.2rem;
}

.dropdown-item {
  font-size: 0.9rem;
  font-weight: 500;
  color: #4b5563;
  transition: all 0.2s;
}

.dropdown-item:hover {
  background-color: #f8fafc;
  color: #558e19;
  padding-left: 1.25rem;
}

.text-xs {
  font-size: 0.75rem;
}

.dropdown-divider {
  margin: 0.5rem 0;
}
</style>